import { IUrlInformation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import { ICompactProduct } from "../../api/interfaces/get-page-details/common/CompactProduct.type";
import { PAGE_TYPES } from "./product-constants";

export function getProductHeading(product: ICompactProduct, pageDetails?: any, pageType?: string | null, urlInformation?: IUrlInformation | null) {
  const {
    manufacturer, description, partNumber, longDescription,
  } = product || {};
  if (urlInformation) {
    const { yearRange = [], year } = urlInformation;
    if (pageType === PAGE_TYPES.PRODUCT_FITMENT) {
      const vehicleInfo = `${year} ${urlInformation.make} ${urlInformation.model}`;
      return longDescription ? `${vehicleInfo} ${longDescription}`
        : `${vehicleInfo} ${description} by ${manufacturer} - ${partNumber}`;
    }
    if (pageType === PAGE_TYPES.PRODUCT_MAKE_MODEL_PAGE && yearRange.length) {
      const vehicleInfo = `${yearRange[0]}-${yearRange[yearRange.length - 1]} ${urlInformation.make} ${urlInformation.model}`;
      return longDescription ? `${vehicleInfo} ${longDescription}`
        : `${vehicleInfo} ${description} by ${manufacturer} - ${partNumber}`;
    }
  }
  return longDescription || pageDetails?.pageDisplayableTitle || `${description} by ${manufacturer} - ${partNumber}`;
}
